import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DefaultLayout } from 'src/components/layouts/DefaultLayout';
import AnnotaionText from 'src/components/atoms/form/AnnotationText';
import Heading from 'src/components/atoms/typo/Heading';
import { DefaultPageProps, HistoryProps } from 'src/constants/Interface';
import StyleConfig from 'src/constants/StyleConfig';
import PushNotificationForm from 'src/components/organisms/form/PushNotificationForm';
import * as masterActions from 'src/state/ducks/master/actions';
import { MessageEntity } from 'src/firebase/db/Messages';

type Props = DefaultPageProps &
  HistoryProps &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class PushNotificationPage extends Component<Props> {
  render() {
    const { draft, errors, createPushMessage } = this.props;
    return (
      <DefaultLayout {...this.props}>
        <Styled>
          <Heading tag={'h1'} text={'プッシュ通知を送信します'} />
          <AnnotaionText text={'※参加者全体に送信されるため、実行には十分注意してください'} />
          <PushNotificationForm
            formType={'CREATE'}
            message={draft}
            errors={errors}
            onSubmit={createPushMessage}
          />
        </Styled>
      </DefaultLayout>
    );
  }
}

const Styled = styled.div`
  box-sizing: border-box;
  padding: ${StyleConfig.HELPER.M20};
`;

const mapStateToProps = (state: any) => {
  return {
    draft: state.master.message.draft,
    errors: state.master.message.validationErrors,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    getPushMessages: () => dispatch(masterActions.getPushMessages()),
    createPushMessage: (query: MessageEntity) => dispatch(masterActions.createPushMessage(query)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PushNotificationPage);
